import React from 'react'
import { Layout } from '../../components/Layout'
import { LayoutContent } from '../../components/LayoutContent'
import { Filter } from '../../components/filter/Filter'
import { SuppliersOrInvoiceGroup } from './SuppliersOrInvoiceGroup'

export function SupplierPage(): React.JSX.Element {
  return (
    <Layout title='Leverantörer' headerContent={<Filter />}>
      <LayoutContent>
        <SuppliersOrInvoiceGroup />
      </LayoutContent>
    </Layout>
  )
}
